<template>
	<div class="shipment-list flex-center">
		<div class="mr-3">
			<shipment-history
				:history="history"
				:courier="courier">
			</shipment-history>
		</div>
		<div class="shipment-history-notes">
			<div class="font-weight-bold">{{ date }}</div>
			<div>{{ history.notes }}</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import ShipmentHistory from '@/components/ShipmentHistory.vue';

export default {
	name: 'ShipmentList',
	components: {
		ShipmentHistory,
	},
	props: {
		courier: {
			type: String,
		},
		history: {
			type: Object,
		},
	},
	computed: {
		date() {
			let date = '-';
			if (this.courier === 'jne') {
				date = this.history.date;
			} else {
				date = dayjs(this.history.date).format('DD-MM-YYYY HH:mm');
			}
			return date;
		},
	},
};
</script>

<style lang="scss">
@import '../assets/scss/modules/_variables.scss';

.shipment-list {
	position: relative;
	padding: .5em;
	border-bottom: 1px dashed $color__border;

	&:last-child {
		border-bottom: 0;
	}
}
</style>
